package signSymptom.containers


import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.signSymptom.model.SignSymptomDetail
import react.*
import react.dom.div
import setTitle
import signSymptom.components.SignSymptomDetail

external interface SignSymptomDetailPageProps : RProps {
   var id:String
}

data class SignSymptomDetailPageContextData(
    var getDetail:(id:String, okCallback: (result:ApiResponse<SignSymptomDetail>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getComments:(entityType:CommentEntityType, entityId:String, type:CommentType, okCallback: (result:ApiResponse<Array<Comment>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var saveComment:(comment:Comment, okCallback: (result:ApiResponse<Comment>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val SignSymptomDetailPageContext = createContext(SignSymptomDetailPageContextData(SignSymptomApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save))

val SignSymptomDetailPageProvider = functionalComponent<SignSymptomDetailPageProps> { props ->

    setTitle("体征症状")

    useEffectOnce { }

    SignSymptomDetailPageContext.Provider(SignSymptomDetailPageContextData(SignSymptomApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save)) {
        div("SignSymptomDetailPage-page") {
            child(SignSymptomDetail) {
                attrs{
                    id = props.id
                }
            }
        }
    }
}
